import React, { useState, useEffect } from 'react';

import { WarningText, OnbordingContainer, ButtonsWrapper } from '../styledComponents';
import { CheckedIcon, CreateClientWrapper, ImptyIcon } from './styledComponents';
import SmallButtonStyled from '../../../components/Buttons/SmallButtonStyled';
import { ModalHeaderWrapper } from '../styledComponents';
import Button from '../../../components/Buttons/Button';
import BaseModal from '../../../components/BaseModal';
import doFetch from '../../../api/doFetch';

export default function ApiClientModal({ isOpen, onClose, partner, reloadPartners, type }) {
  const [isCopied, setIsCopied] = useState(false);
  const [newClient, setNewClient] = useState(null);
  const [updated, setUpdated] = useState(false);
  const [onbording, setOnbording] = useState('');
  const [checked, setChecked] = useState(['verification:read']);

  const scopes = [
    {
      code: 'verification:read',
      text: 'Read VIN verification records (standard channel).',
      disabled: true
    },
    {
      code: 'verification:enriched',
      text: 'Enriched verification access with richer location/evidence detail.'
    }
  ];

  const generateClient = async () => {
    try {
      const url = `/lotlenz/partners/${partner.id}/oauth-clients`;
      const result = await doFetch(url, {
        method: 'POST',
        body: JSON.stringify({ type, scopes: checked })
      });

      if (result) {
        setNewClient(result);
        setUpdated(true);
      }
    } catch (error) {
      console.error('Error generating key:', error);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(onbording);
      setIsCopied(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheck = (code) => {
    if (checked.includes(code)) {
      setChecked((scopes) => scopes.filter((scope) => scope !== code));
    } else {
      setChecked((scopes) => [...scopes, code]);
    }
  };

  const handleCloseOrBack = () => {
    reloadPartners();
    onClose();
  };

  useEffect(() => {
    if (newClient) {
      console.log(type);
      const onbording =
        type === 'mcp'
          ? `Welcome! Here are your MCP credentials:

  Login: ${newClient?.client_id}
  Password: ${newClient?.client_secret}

Authorization: OAuth 2.1
Scope:    ${checked.join(' ')} 

Endpoint: https://mcp.lotlenz.com
Schema:   https://mcp.lotlenz.com/schema

Help: support@example.com`
          : `Welcome! Here are your API credentials:

  Client ID: ${newClient?.client_id}
  Client Secret: ${newClient?.client_secret}

Authorization: OAuth 2.0
Scope:    ${checked.join(' ')} 

Endpoint: https://api.lotlenz.com/v2
Documentation: https://api.lotlenz.com/v2/docs
Schema:   https://api.lotlenz.com/v2/docs-json

Help: support@example.com
    `;

      setOnbording(onbording);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newClient]);

  return (
    <BaseModal
      isOpen={isOpen}
      toggleHandler={handleCloseOrBack}
      header={<ModalHeaderWrapper>YOUR NEW CLIENT</ModalHeaderWrapper>}
      width={488}
    >
      {updated ? (
        <>
          <WarningText>
            Please copy your credentials now. <br />
            For security reasons, they are stored encrypted and cannot be displayed again after you
            close this window.
          </WarningText>
          <OnbordingContainer
            dangerouslySetInnerHTML={{
              __html: onbording.replace(/\n/g, '<br/>')
            }}
          />
          <ButtonsWrapper>
            <ButtonsWrapper>
              <SmallButtonStyled type='button' onClick={handleCopy}>
                {isCopied ? 'Copied!' : 'Copy to clipboard'}
              </SmallButtonStyled>

              <SmallButtonStyled type='button' onClick={handleCloseOrBack} disabled={!isCopied}>
                I have copied it, go back
              </SmallButtonStyled>
            </ButtonsWrapper>
          </ButtonsWrapper>
        </>
      ) : (
        <CreateClientWrapper>
          <div className='body'>
            {scopes.map((s) => (
              <div
                className='row'
                onClick={() => handleCheck(s.code)}
                key={s.code}
                style={s.disabled ? { pointerEvents: 'none' } : {}}
              >
                <div className='check'>
                  {checked.includes(s.code) ? <CheckedIcon /> : <ImptyIcon />} {s.code}
                </div>
                <div>{s.text}</div>
              </div>
            ))}
          </div>
          <ButtonsWrapper>
            <ButtonsWrapper>
              <Button onClick={generateClient}>Create</Button>
            </ButtonsWrapper>
          </ButtonsWrapper>
        </CreateClientWrapper>
      )}
    </BaseModal>
  );
}
